import { useState } from "react";
import { Text } from "@aidron/aidron-ds";
import { CustomHeading } from "../../../../../components/StyledComponents/styleComponents.index";

const overlayStyle = {
  position: "fixed",
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
  backdropFilter: "blur(2px)",
};

const modalStyle = {
  backgroundColor: "#fff",
  borderRadius: "12px",
  padding: "32px",
  boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "16px",
  maxWidth: "480px",
  inlineSize: "100%",
  textAlign: "center",
};

const inputStyle = {
  inlineSize: "100%",
  boxSizing: "border-box",
  padding: "10px 14px",
  borderRadius: "8px",
  border: "1px solid #ddd",
  fontSize: "14px",
};

const warningBoxStyle = {
  backgroundColor: "#FDEDE3",
  borderRadius: "8px",
  padding: "12px 16px",
  inlineSize: "100%",
  boxSizing: "border-box",
  textAlign: "left",
};

const baseButtonStyle = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  padding: "9px 18px",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "14px",
  fontWeight: 600,
};

export const OtbSaveVersionModal = ({ actions, ctx }) => {
  const { onConfirm, onCancel } = actions || {};
  const { 
    otbName, 
    categoriesCount, 
    incompleteEdits = [], 
    isSaving = false 
  } = ctx || {};

  const [versionName, setVersionName] = useState("");

  const confirmButtonStyle = {
    ...baseButtonStyle,
    backgroundColor: "#e8773a",
    color: "#fff",
    opacity: 1,
  };

  const confirmButtonDisabledStyle = {
    ...confirmButtonStyle,
    backgroundColor: "#e8773a",
    opacity: 0.5,
    cursor: "not-allowed",
  };

  const cancelButtonStyle = {
    ...baseButtonStyle,
    backgroundColor: "#fff",
    color: "#374151",
    border: "1px solid #ddd",
  };

  const hasIncomplete = incompleteEdits.length > 0;
  const canConfirm = versionName.trim().length > 0 && !hasIncomplete;

  const monthLabel = (year, month) => `${String(month).padStart(2, '0')}/${year}`;

  return (
    <div style={overlayStyle} onClick={onCancel}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <CustomHeading size="sm" margin="0 0 16px">
          Salvar versão
        </CustomHeading>

        <Text
          label={`Você está salvando uma simulação para "${otbName}", com alterações em ${categoriesCount} categoria(s).`}
        />

        {hasIncomplete && (
          <div style={warningBoxStyle}>
            <Text
              label="As edições abaixo estão incompletas (faltam ao menos 2 dos 3 campos: faturamento, peças vendidas ou preço médio) e precisam ser ajustadas antes de salvar:"
              size="sm"
              weight="bold"
            />
            {incompleteEdits.map((edit, i) => (
              <Text
                key={`${edit.categoria}-${edit.year}-${edit.month}-${i}`}
                label={`• ${edit.categoria} — ${monthLabel(edit.year, edit.month)}`}
                size="sm"
              />
            ))}
          </div>
        )}

        <input
          style={inputStyle}
          type="text"
          placeholder="Nome da versão (ex: Revisão Agosto)"
          value={versionName}
          onChange={(e) => setVersionName(e.target.value)}
          autoFocus
        />

        <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
          <button
            type="button"
            style={canConfirm && !isSaving ? confirmButtonStyle : confirmButtonDisabledStyle}
            disabled={!canConfirm || isSaving}
            onClick={() => onConfirm(versionName.trim())}>
            {isSaving ? "Salvando..." : "Salvar"}
          </button>

          <button
            type="button"
            style={cancelButtonStyle}
            disabled={isSaving}
            onClick={onCancel}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};